import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const stRotate = () => {

    const animation = document.querySelectorAll('[data-animation="rotate"]');
    if(!animation) return;

    animation.forEach(element => {
        gsap.to(element, {
            rotation: 360*0.5,
            ease: 'none',
            scrollTrigger: {
                scrub: 2,
                start: 'top top',
                end: '+=10000'
            }
        })
    });

}

export { stRotate }